import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Size, Stack, TextInput } from '@optimus-web/core';

export interface FormMeta {
    creatorName?: string;
    updaterName?: string;
    createdDateTime: string;
    updatedDateTime: string;
}

interface Props {
    meta?: FormMeta;
    size?: Size;
}

const formatValue = (dateTime: string, userName?: string) =>
    `${dateTime} ${userName === undefined ? '' : `(${userName})`}`;

const FormMetaSection = ({ meta, size }: Props) => {
    if (meta === undefined) {
        return null;
    }

    const { createdDateTime, creatorName, updatedDateTime, updaterName } = meta;

    const createdMetaValue = formatValue(createdDateTime, creatorName);
    const updatedMetaValue = formatValue(updatedDateTime, updaterName);

    return (
        <Stack spacing="200" vertical>
            <TextInput
                name="createdMeta"
                label={<LocalizedText textKey={TextKey.Created} />}
                value={createdMetaValue}
                disabled
                size={size}
            />
            <TextInput
                name="updatedMeta"
                label={<LocalizedText textKey={TextKey.Updated} />}
                value={updatedMetaValue}
                disabled
                size={size}
            />
        </Stack>
    );
};

export default FormMetaSection;
